import React from 'react';

export default function ChatGPT3() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='#000'>
            <path d='M8.2 19L9 13.4H5L12.2 3H13.8L13 9.4H17.8L9.8 19H8.2Z' />
        </svg>
    );
}
